// DBT-228 — iscrizioni chiuse: codice e testo UNICI per tutta l'app.
// Il testo è quello deciso da Vale l'08/10 (DEC-169, riformulato con DEC-171) e deve restare identico a
// `MSG_ISCRIZIONI_CHIUSE` del backend (apps/users/registrazione.py): una prova
// del backend (tests_iscrizioni_chiuse.py) diventa rossa se i due divergono.
export const CODICE_ISCRIZIONI_CHIUSE = 'registrazione_chiusa';

export const MSG_ISCRIZIONI_CHIUSE = 'Le iscrizioni a mAIstro apriranno a breve. Richiedi una demo: ti avvisiamo appena puoi iniziare la prova gratuita di 14 giorni.';

// Il modulo «Richiedi una demo» vive nella pagina pubblica, servita dal backend.
export function urlRichiediDemo(base = process.env.REACT_APP_API_URL || '') {
  return `${base}/#demo`;
}

// CAP-024 (DEC-176) — lista d'attesa: testi e regole condivise, provate in
// iscrizioniChiuse.test.js. Nessuna password: il modulo raccoglie solo contatti.
export const MSG_LISTA_ATTESA_FATTO = 'Fatto: ti avvisiamo appena aprono le iscrizioni.';
// Conservazione decisa da Vale il 09/10 ([[DEC-180]]).
export const MSG_LISTA_ATTESA_PRIVACY = "Usiamo il tuo contatto solo per avvisarti quando aprono le iscrizioni: lo cancelliamo entro 6 mesi dall'apertura, e comunque non oltre 12 mesi dall'iscrizione.";

export function emailValida(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test((email || '').trim());
}

// Dati da inviare: solo i campi del contatto, puliti. Il campo trappola
// (`sito_web`) viaggia così com'è: se un programma lo riempie, il server scarta.
export function datiListaAttesa({ email, nome, telefono, sitoWeb }, provenienza = 'app') {
  return {
    email: (email || '').trim().toLowerCase(),
    nome: (nome || '').trim(),
    telefono: (telefono || '').trim(),
    provenienza,
    sito_web: sitoWeb || '',
  };
}

export function erroreListaAttesa(err) {
  const status = err?.response?.status;
  if (!err?.response) return 'Connessione assente. Riprova tra qualche secondo.';
  if (status === 429) return 'Troppe richieste da questa connessione. Riprova più tardi.';
  return err.response.data?.error || 'Non siamo riusciti a salvare il contatto. Riprova tra qualche istante.';
}
